import Header from "../Components/Header/Header";
import styled from "styled-components";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import FooterCommon from "../Components/FooterCommon/FooterCommon";
export const ComponentWrapper = styled.div`
  &.with-toolbar {
    margin-top: 173px;
  }
  &.no-toolbar {
    margin-top: 123px;
  }
`;

export function withHeaderFooter(WrappedComponent) {
  return function (props) {
    const [withToolbar, setWithToolbar] = useState(false);
    const [showFooter, setShowFooter] = useState(false);
    const [specialRoute, setSpecialRoute] = useState(false);
    const location = useLocation();
    useEffect(() => {
      // if (location.pathname.includes('/web-portal/fibe')) {
      //   setSpecialRoute(false);
      // }
      // else {
      //   setSpecialRoute(false);
      // }
      if (location.pathname.includes('/dashboard') ) {
        setWithToolbar(true);
      } else {
        setWithToolbar(false);
      }
      if (location.pathname.includes("service-request")) {
        setShowFooter(false);
      } else {
        setShowFooter(true);
      }
    }, [location.pathname]);
    return (
      <ComponentWrapper className={false ? "with-toolbar" : "no-toolbar"}>
        <Header withToolbar={withToolbar} />
        <WrappedComponent {...props} />
        {true && <FooterCommon />}
      </ComponentWrapper>
    );
  };
}
